import React from 'react';
import { LIVE_CHAT_DROP_ZONES } from 'components/chat-dynamic-location/utils/draggable-chat-constants';

export const LiveChatLayoutContext = React.createContext({
  liveChatLayout: LIVE_CHAT_DROP_ZONES.BOTTOM_RIGHT,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setLiveChatLayout: (liveChatLayout: LIVE_CHAT_DROP_ZONES) => {},
});
